<template>
    <div class="final-storybook">
        <div v-if="isCompleted" class="final-storybook-header">
            <div class="storybook-header-left">
                <img :src="require('@/assets/icons/pr-completed.svg')" />
                <div class="completed-msg">
                    <h2 class="title">Storybank generated</h2>
                </div>
            </div>

            <div class="storybook-header-right">
                <div class="storybook-btn-wrapper">
                    <img :src="require('@/assets/icons/share.svg')"></img>
                    <p class="home-btn-text">Share</p>
                </div>

                <button class="storybook-btn-wrapper" @click="goToHome()">
                    <img :src="require('@/assets/icons/home.svg')" alt="">
                    <p class="home-btn-text">Go to Dashboard</p>
                </button>

                <button class="storybook-btn-wrapper" :disabled="downloadLoader" @click="downloadFinalStorybank()">

                    <div class="download-wrapper">
                        <Svg :src="require('@/assets/icons/download.svg')" fill="white"></Svg>
                        <p>Download</p>
                        <v-progress-circular v-if="downloadLoader" indeterminate :size="18"
                            :width="2"></v-progress-circular>
                    </div>

                </button>
            </div>
        </div>

        <div v-else class="completed-doc-header-left">
            <div class="doc-name-editor-wrapper">
                <span class="doc-title">{{ docName }}</span>
                <RenamePopup
                    v-if="isEditingTitle"
                    :docName="docName"
                    :isEditing="isEditingTitle"
                    :id="$route.params.storyBankId"
                    flowType="storyBank"
                    @update-isEdit="isEditingTitle = $event"
                    @updated-prTitle="docName = $event"
                />
                <button class="edit-btn" @click="isEditingTitle = true">
                    <img :src="require('@/assets/icons/edit.svg')" />
                </button>
            </div>
        </div>

        <div class="body">
            <div class="body-wrapper">
                <div class="body-content" v-html="cleanedStoryBankCampaignContent"></div>
            </div>
        </div>
    </div>

</template>

<script>
import { marked } from 'marked';
import RenamePopup from '@/components/RenamePopup.vue';
import { downloadPr } from '@/helper/downloadPr';

export default {
    data() {
        return {
            downloadLoader: false,
            storyBankCampaignContent: null,
            isEditingTitle: false,
            docName: null
        }
    },
    components: { RenamePopup },
    props: {
        storyBank: { type: Object },
        isCompleted: { type: Boolean },
        modelValue: { type: String }
    },

    computed: {
        cleanedStoryBankCampaignContent() {
            return this.storyBank;
        }
    },

    watch: {
        docName: {
            deep: true,
            handler(val) {
                this.$emit('update:modelValue', val);
            }
        }
    },

    methods: {
        goToHome() {
            this.$store.dispatch('updateIsGeneratePopup', false);
            this.$router.push({ name: 'storyBankHome' });
        },

        async downloadFinalStorybank() {
            this.downloadLoader = true;
            const payload = {
                storyBankId: this.$route.params.storyBankId,
                flowType: "STORY_BANK"
            };
            await downloadPr(payload, this.modelValue);
            this.downloadLoader = false;
        }
    },

    mounted() {
        this.storyBankCampaignContent = this.storyBank;
        this.docName = this.modelValue;
    }
}
</script>

<style scoped>
.final-storybook {
    display: flex;
    flex-direction: column;
    padding: 2rem;
    width: 80%;
    overflow: hidden;
    gap: 2rem;
    box-sizing: border-box;
}

.final-storybook-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1.5em;
    background: var(--primary-gradient-bar-with-black);
    padding: 1rem 1.5rem;
    border-radius: 8px;
    color: var(--secondary-font-color);
    justify-content: space-between;
}

.storybook-header-left {
    display: flex;
    gap: 1rem;
}

.storybook-header-right {
    display: flex;
    flex-direction: row;
    gap: 1rem;
}

.storybook-btn-wrapper {
    display: flex;
    justify-content: center;
    background: #FFFFFF1F;
    gap: 4px;
    padding: 0.5rem 1rem;
    border: 1px solid #FFFFFF33;
    align-items: center;
    border-radius: 8px;
    font-size: var(--normal-font-size);
}

.download-wrapper {
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    justify-content: center;
    align-items: center;
}

.completed-doc-header-left {
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: flex-start;
}

.doc-name-editor-wrapper {
    display: flex;
    align-items: center;
    gap: 16px;
    color: white;
}

.doc-title {
    font-size: 24px;
}

.doc-name-editor-wrapper .edit-btn {
    display: flex;
    border-radius: 8px;
    border: 1px solid #FFFFFF33;
    align-items: center;
    cursor: pointer;
    background: none;
}

.edit-btn {
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
    border-radius: 50%;
    border: 1px solid #A3A3A3;
    background: white;
}

.body {
    background-color: var(--secondary-font-color);
    border-radius: 8px;
    padding: 1rem;
    overflow: hidden;
}

.body-wrapper {
    height: 100%;
    overflow: auto;
    scrollbar-width: none;
    will-change: transform;
}

.body-content {
    display: flex;
    background-color: white;
    flex-direction: column;
    border-radius: 6px;
    padding: 1rem;
    color: black;
    gap: 1rem;
}

.body-content ul {
    padding: 1rem !important;
}

.title {
    display: flex;
    padding: 8px;
    flex: 1;
    justify-content: center;
    align-items: center;
}
</style>
